<div class="slider">
  <splide [options]="sliderOptions" class="slider slider--pink">
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/how-to-win/slides/slide-1.png" alt="Slide 1" class="m-auto">
        </div>
        <div class="slider__desc">
          For Football Bingo, events on either side of your card must be completed by each specific team.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/how-to-win/slides/slide-2.png" alt="Slide 2" class="m-auto">
        </div>
        <div class="slider__desc">
          Events in the middle column can occur at any time, for either team.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/how-to-win/slides/slide-3.png" alt="Slide 3" class="m-auto">
        </div>
        <div class="slider__desc">
          Tapping on any icon will give you a definition for that event.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/how-to-win/slides/slide-4.png" alt="Slide 4" class="m-auto">
        </div>
        <div class="slider__desc">
          As each live event occurs, it is checked off on your game card in near real-time.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/how-to-win/slides/slide-5.png" alt="Slide 5" class="m-auto">
        </div>
        <div class="slider__desc">
          Be the first to complete 1 Line, 2 Lines or a Full House.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/how-to-win/slides/slide-6.png" alt="Slide 6" class="m-auto">
        </div>
        <div class="slider__desc">
          The game continues until the final whistle is blown.
        </div>
      </div>
    </splide-slide>
  </splide>
</div>
